import global from '../patterns/global-variables';
import $ from 'jquery';
window.jQuery = $;
import utils from '../patterns/utils';
import PL_utils from '../patterns/pl-utils.js';

const ModalTriggers = document.getElementById("listings-container");

const noListingsFoundMessage = () => {
    appendElement("<p>Currently, you do not have any active practice locations on the Indivior Find a SUBLOCADE Treatment Provider Tool. Get&nbsp;started by clicking <strong>Add New&nbsp;Practice&nbsp;Location</strong>.</p>");
};

const ListingsFoundMessage = () => {
    appendElement("<p>Your active practice locations on the Indivior Find a SUBLOCADE Treatment Provider Tool are listed below. Select a location and click <strong>Edit Practice Location</strong> to update the listing information, or click <strong>Add New Practice Location</strong> to request a new&nbsp;location. Please allow 2 to 3 business days for processing.</p>");
};

const addNewPracticeLocationButton = () => {
    appendElement('<a href="/add-listing" id="add-treatment-site" class="btn btn-primary mb-40 mt-30"><span class="btn-content">Add New Practice Location</a>');
};

const showActiveListing = (data) => {
    let phoneArr = data.PhoneNumber.split('');
    let formattedPhone = `(${phoneArr.slice(0, 3).join('')}) ${phoneArr.slice(3, 6).join('')}-${phoneArr.slice(6).join('')}`;
    const newActiveListening = `<div class="listings active-listings">
    <div class="row">
        <div class="one-half column">
            <div class="row">
                <h2>${data.name}</h2>
            </div>
            ${data.PracticeName != '' && data.PracticeName != undefined ? `<div class="row"><p>${data.PracticeName}</p> </div>` : ''}
            <div class="row">
                <div class="one-half column">
                    <p class="address-label"><strong>Address</strong></p>
                    <p>${data.addressLine}</p>
                </div>
                <div class="one-half column">
                    <p class="phone-label"><strong>Phone Number</strong></p>
                    <p>${formattedPhone}</p>
                </div>
            </div>
            <div class="row mt-20 map-row">
                <a href="/edit-listing?id=${data.LocationId}" class="btn btn-primary edit-listing"><span class="btn-content">Edit Practice Location</span></a>
            </div>
        </div>
        <div class="one-half column">
            ${data.Map || `<div class="map" id="googlemap-${data.LocationId}"></div>`}
        </div>
    </div></div>`;

    return newActiveListening;
};

const showPendingListing = (data, pendingType) => {
    let phoneArr = data.PhoneNumber.split('');
    let formattedPhone = `(${phoneArr.slice(0, 3).join('')}) ${phoneArr.slice(3, 6).join('')}-${phoneArr.slice(6).join('')}`;
    const newPendingListening = `<div class="listings pending-listings">
    <div class="row">
        <div class="one-half column">
            <div class="row">
                <p class='svg-pending'>
                    <svg class="svg--icon-pending">
                        <use xlink:href="#icon-pending"></use>
                    </svg>
                    ${pendingType}
                </p>
            </div>
            <div class="row">
                <h2>${data.name}</h2>
            </div>
            ${data.PracticeName != '' && data.PracticeName != undefined ? `<div class="row"><p>${data.PracticeName}</p> </div>` : ''}
            <div class="row">
                <div class="one-half column">
                    <p class="address-label"><strong>Address</strong></p>
                    <p>${data.addressLine}</p>
                </div>
                <div class="one-half column pl-20-desktop">
                    <p class="phone-label"><strong>Phone Number</strong></p>
                    <p>${formattedPhone}</p>
                </div>
            </div>
            <div class="row mt-20 map-row">
            </div>
        </div>
        <div class="one-half column">
            ${data.Map || `<div class="map" id="googlemap-${data.LocationId}"></div>`}
        </div>
    </div></div>`;

    return newPendingListening;
};

const appendElement = (context) => {
    ModalTriggers.innerHTML += context;
};

const transformData = (data) => {
    data.name = `${data.FirstName} ${data.LastName}`;
    data.addressLine = `${data.Address}<br/>${data.City}, ${data.State} ${data.Zip}`;
    return data;
};

const screenshot = () => {
    const dataPlaceHolder = [
        {
            FirstName: '[FName]',
            LastName: '[LName]',
            PracticeName: '[Practice/Facility Name]',
            Address: '123 Main Street',
            City: 'Beverly Hills',
            State: 'CA',
            Zip: '90210',
            PhoneNumber: '5555555555',
            Map: '<img class="map-placeholder" src="/assets/img/shared/mapPlaceHolder.png" alt="map place holder">',
        },
        {
            FirstName: '[FName]',
            LastName: '[LName]',
            PracticeName: '[Practice/Facility Name]',
            Address: '111 Main Street',
            City: 'Beverly Hills',
            State: 'CA',
            Zip: '90210',
            PhoneNumber: '5556666666',
            Map: '<img class="map-placeholder" src="/assets/img/shared/mapPlaceHolder.png" alt="map place holder">',
        },
        {
            FirstName: '[FName]',
            LastName: '[LName]',
            PracticeName: '[Practice/Facility Name]',
            Address: '222 Main Street',
            City: 'Beverly Hills',
            State: 'CA',
            Zip: '90210',
            PhoneNumber: '5557777777',
            Map: '<img class="map-placeholder" src="/assets/img/shared/mapPlaceHolder.png" alt="map place holder">',
        },
        {
            FirstName: '[FName]',
            LastName: '[LName]',
            PracticeName: '[Practice/Facility Name]',
            Address: '333 Main Street',
            City: 'Beverly Hills',
            State: 'CA',
            Zip: '90210',
            PhoneNumber: '5558888888',
            Map: '<img class="map-placeholder" src="/assets/img/shared/mapPlaceHolder.png" alt="map place holder">',
        },
    ];
    if (window.location.href.indexOf('practice-listings=0') > -1) {
        noListingsFoundMessage();
        addNewPracticeLocationButton();
    }
    if (window.location.href.indexOf('practice-listings=1') > -1) {
        ListingsFoundMessage();
        addNewPracticeLocationButton();
        appendElement('<h3>ACTIVE LISTINGS</h3>');
        appendElement(showActiveListing(transformData(dataPlaceHolder[0])));
        document.querySelector(".btn.btn-primary.edit-listing").href = "/edit-listing/?ed=1&sign-in=1"
        appendElement('<h3 class="mt-40">PENDING LISTINGS</h3>');
        appendElement(showPendingListing(transformData(dataPlaceHolder[1]), "PENDING ADD"));
        appendElement(showPendingListing(transformData(dataPlaceHolder[2]), "PENDING UPDATE"));
        appendElement(showPendingListing(transformData(dataPlaceHolder[3]), "PENDING DELETE"));
    }
};


export default () => {
    if (global.IS_ED_MODE) {
        screenshot();
    } else {
        const csrfToken = utils.getCookie('csrfToken');

        if (csrfToken) {
            PL_utils.removeClass("hidden", document.querySelector("#listings-loading"));
            $.ajax(global.API_ENDPOINT() + '/location/list', {
                dataType: 'json',
                method: 'GET',
                headers: {
                    'csrf-token': csrfToken,
                },
                xhrFields: {
                    withCredentials: true,
                }
            })
            .done(function (resp) {
                PL_utils.addClass("hidden", document.querySelector("#listings-loading"));
                if (resp.success) {
                    if (resp.data.addresses.length > 0) {
                        ListingsFoundMessage();
                        addNewPracticeLocationButton();

                        appendElement('<h3>ACTIVE LISTINGS</h3>');
                        resp.data.addresses.filter(function(a) { return utils.toLowercase(a.Status) == 'approved'; }).forEach(function(a) { appendElement(showActiveListing(transformData(a))); });

                        appendElement('<h3 class="mt-40">PENDING LISTINGS</h3>');
                        resp.data.addresses.filter(function(a) { return utils.toLowercase(a.Status) != 'approved'; }).sort(function(a, b) { return Date.parse(b.DateUpdate) - Date.parse(a.DateUpdate);})
                        .forEach(function(a) {
                            appendElement(showPendingListing(transformData(a), global.PENDING_STATUS_LIST[utils.toLowercase(a.Status)]));
                        });

                        // Generate a Google map of the location, non-editable
                        resp.data.addresses.forEach(a => {
                            utils.renderGoogleMap(a.Latitude, a.Longitude, `googlemap-${a.LocationId}`, false);
                        });
                    } else {
                        noListingsFoundMessage();
                        addNewPracticeLocationButton();
                    }
                } else if (resp.data.errorCode == 'E001' || resp.data.errorCode == 'E002') {
                    console.error(JSON.stringify(resp));
                    window.location.href = "/";
                } else {
                    console.error(JSON.stringify(resp));
                    window.location.href = "/server-error";
                }
            })
            .fail(function (err) {
                console.error(JSON.stringify(err));
                PL_utils.addClass("hidden", document.querySelector("#listings-loading"));
                window.location.href = "/server-error";
            })
        } else {
            window.location.href = "/";
        }
    }
};
